import { Plugin } from 'ckeditor5/src/core';
import AccordionUI from './accordionui';
import AccordionEditing from './accordionediting';

export default class Accordion extends Plugin {
	static get pluginName() {
		return 'Accordion';
	}
	static get requires() {
		return [AccordionEditing, AccordionUI];
	}
}
